<template>
  <div class="bottom-slider-popup">
    <img src="~@/assets/images/desktop/icons/arrow-up.svg" class="icon-svg white-filter c-pointer" @click="showPopup = true">
    <DxPopup
        :visible.sync="showPopup"
        :height="300"
        :width="'100%'"
        :position="popupPosition"
        :animation="popupAnimation"
        :show-title="false"
        :drag-enabled="false"
        :hide-on-outside-click="true"
    >
      <div class="popup-content">
        <div class="popup-head">
          <h3 v-if="title" class="popup-title">{{ title }}</h3>
          <img class="color-filter-close-ico c-pointer" @click="closePopup" v-if="!hideCloseButton" src="@/assets/images/icons/dialog-close-gray.svg"/>
        </div>
        <div class="popup-content-slot">
          <slot></slot>
        </div>
      </div>
    </DxPopup>
  </div>
</template>

<script>
import { DxPopup } from 'devextreme-vue/popup';
import { DxButton } from 'devextreme-vue/button';

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String|null,
    },
    hideCloseButton: {
      type: Boolean,
      default: false,
    },
    showOpenButton: {
      type: Boolean,
      default: false,
    }
  },
  components: {
    DxPopup,
    DxButton,
  },
  data() {
    return {
      showPopup: false,
      popupPosition: {
        my: 'bottom',
        at: 'bottom',
        of: window,
      },
      popupAnimation: {
        show: {
          type: 'slide',
          duration: 300,
          from: { top: window.innerHeight },
          to: { top: window.innerHeight - 300 },
        },
        hide: {
          type: 'slide',
          duration: 300,
          to: { top: window.innerHeight },
          from: { top: window.innerHeight - 300 },
        },
      },
    };
  },
  methods: {
    closePopup() {
      this.showPopup = false;
      this.$emit('onClose', true);
    },
  },
  watch: {
    show: function (newVal) {
      this.showPopup = newVal;
    },
  }
};
</script>

<style lang="scss" scoped>
.popup-content {
  display: flex;
  flex-direction: column;
  padding: 40px 20px 20px 20px;
  overflow-y: auto;

  .popup-head {
    display: flex;
    flex-grow: 1;

    .popup-title {
      flex-grow: 1;
    }
  }
}

.icon-svg {
  position: relative;
  top: -6px;
  left: 10px;
}
</style>
